import '../base';
import '../objects/product/ProductThumbnail';
